module.exports = __webpack_public_path__ + "img/gift-dialog.336f8be0.png";